/* ------------------------------------------------------------------
   File: About.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-05-10
------------------------------------------------------------------ */

import React from 'react'

function About() {
  return (
    <div>
      This is About Page
    </div>
  )
}

export default About
